const isLoggedIn = () => {
    return false;
};

export default isLoggedIn;
